import React, { type ComponentPropsWithoutRef, forwardRef } from 'react';

import { Flex } from '../Flex';
import { Portal } from '../Portal';

import { Styled } from './styles';
import type { ToasterProps } from './types';

export type { ToasterProps } from './types';

type DivProps = Omit<ComponentPropsWithoutRef<'div'>, keyof ToasterProps>;

type Props = DivProps & ToasterProps;

export const Toaster = forwardRef<HTMLDivElement, Props>(
  ({ target = globalThis.document?.body, children, position = 'fixed', top, ...props }, ref) => (
    <Portal target={target}>
      <Styled.Toaster {...props} ref={ref} top={top} position={position}>
        <Flex.Column space="s">{children}</Flex.Column>
      </Styled.Toaster>
    </Portal>
  ),
);
Toaster.displayName = 'Toaster';
